import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { __t } from '../../../../../../base/utils/t';
import { recruiterAppActions } from '../../../../../redux/slices/recruiterAppSlice';
import { passwordRecoveryActions } from '../../../redux/slices/passwordRecoverySlice';
import { Confirmation as ConfirmationComponent } from '../../../../../components/Confirmation';

export const Confirmation = () => {
    const dispatch = useAppDispatch();
    const {
        fields: { email, emailCode },
        errors,
    } = useAppSelector((state) => state.recruiterAppPasswordRecovery);

    const emailCodeVerificationCodeChangeHandler = (value: unknown) => {
        dispatch(passwordRecoveryActions.setField({ id: 'emailCode', value }));
    };

    const submitEmailResendCode = (recaptchaToken: string | null, callback: () => void) => {
        dispatch(recruiterAppActions.sendConfirmationCode(email, recaptchaToken, callback));
    };

    const submitCode = () => dispatch(passwordRecoveryActions.submitRecoverPassword());

    const submitChangeConfirmationValue = (newValue: string, recaptchaToken: string | null, callback: () => void) => {
        dispatch(passwordRecoveryActions.submitChangeConfirmationValue(newValue, recaptchaToken, callback));
    };

    return (
        <div className='password-recovery password-recovery__confirmation'>
            <ConfirmationComponent
                confirmationMethod='email'
                codeValue={emailCode || ''}
                text={
                    <>
                        {__t('Чтобы подтвердить действие, введите код отправленный вам на')}&nbsp;
                        <strong>{email}</strong>
                    </>
                }
                codeErrors={errors?.emailCode}
                changeConfirmationValueErrors={errors?.email}
                updateModalText={__t('Email, на которий вы регистрировались')}
                verificationCodeChangeHandler={emailCodeVerificationCodeChangeHandler}
                submitResendCode={submitEmailResendCode}
                submitCode={submitCode}
                submitChangeConfirmationValue={submitChangeConfirmationValue}
            />
        </div>
    );
};
